var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AllRecordsTable',{attrs:{"submit-button-text":"Добавить проект","table-name":"projects","link-slug":"projects","title":"Проекты","columns":_vm.projectsTable.columnNames,"row-links":_vm.projectsTable.rowLinks,"filter-fields":_vm.projectsTable.filterFields,"order-fields":_vm.projectsTable.orderFields,"rows":_vm.projectsTable.rowNames}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6261ab8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/stock/pages/AllProjectsPage.vue
// module id = null
// module chunks = 